import React from 'react';
import clsx from 'clsx';
import {
  readableReportState,
  ReportState,
} from 'views/EMR/components/Panel/RunOutputPanel/types';

const stateClasses: Record<ReportState, string> = {
  Ready: 'text-emerald-600 bg-emerald-100',
  InProgress: 'text-blue-600 bg-blue-50',
  Failed: 'text-red-700 bg-red-100',
};

const dotTextClasses: Record<ReportState, string> = {
  Ready: 'text-emerald-600',
  InProgress: 'text-blue-600',
  Failed: 'text-red-700',
};

const dotClasses: Record<ReportState, string> = {
  Ready: 'bg-emerald-600',
  InProgress: 'bg-blue-600',
  Failed: 'bg-red-700',
};

type Props = {
  state: ReportState;
  variant?: 'chip' | 'dot';
  className?: string;
};

export default function RunStatusChip({ state, variant = 'chip', className }: Props) {
  const isDot = variant === 'dot';

  return (
    <span
      className={clsx(
        'text-xs font-semibold',
        isDot
          ? ['inline-flex items-center gap-1.5', dotTextClasses[state]]
          : ['inline-block rounded-full px-2.5 py-0.5', stateClasses[state]],
        className,
      )}
    >
      {isDot && (
        <span
          aria-hidden
          data-testid="run-status-dot"
          className={clsx('h-2 w-2 rounded-full', dotClasses[state])}
        />
      )}
      {readableReportState[state]}
    </span>
  );
}
